import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  generalSettings: {
    name: '',
    description: '',
  },
  configureFiles: {
    configuration: [],
    outputFilename: null,
    configFilename: null,
    stagingFilename: null,
  },
  activeTaskId: null,
  targetSettings: null,
  mappingObject: {},
  reviewData: [],
  reportdata: null,
  reportFileName: null,
  toggleReviewTab: false,
  toggleReportTab: false,
  isEditMode: false,
  isPreviewMode: false,
  renderParentComponent: false,
};

const unstructuredToStructuredSlice = createSlice({
  name: 'unstructuredToStructured',
  initialState,
  reducers: {
    setGeneralSettings: (state, action) => {
      state.generalSettings = action.payload;
    },
    
    setConfigurations: (state, action) => {
      state.configureFiles.configuration = action.payload;
    },
    setOutputName: (state, action) => {
      state.configureFiles.outputFilename = action.payload;
    },
    setEditedTaskName: (state, action) => {
      state.generalSettings.name = action.payload;
    },
    setEditedTaskDescription: (state, action) => {
      state.generalSettings.description = action.payload;
    },
    setStagingFiles: (state, action) => {
      state.configureFiles.stagingFilename = action.payload;
    },
    setConfigFileName: (state, action) => {
      state.configureFiles.configFilename = action.payload;
    },
    setTargetSettings: (state, action) => {
      state.targetSettings = action.payload;
    },
    setMappingObject: (state, action) => {
      state.mappingObject = action.payload;
    },
    setActiveTaskID: (state, action) => {
      state.activeTaskId = action.payload;
    },
    toggleReviewTab: (state, action) => {
      state.toggleReviewTab = action.payload;
    },
    toggleReportTab: (state, action) => {
      state.toggleReportTab = action.payload;
    },
    setIsEditMode: (state, action) => {
      state.isEditMode = action.payload;
    },
    setIsPreviewMode: (state, action) => {
      state.isPreviewMode = action.payload;
    },
    setReportFileName: (state, action) => {
      state.reportFileName = action.payload;
    },
    setRenderComponent: (state, action) => {
      state.renderParentComponent = action.payload;
    },
    setReviewData: (state, action) => {
      state.reviewData = action.payload;
    },
    setReportData: (state, action) => {
      state.reportdata = action.payload;
    },
    resetState: () => initialState,
  },
});


export const {
  setGeneralSettings,
  setConfigurations,
  setOutputName,
  setEditedTaskName,
  setEditedTaskDescription,
  setStagingFiles,
  setConfigFileName,
  setTargetSettings,
  setMappingObject,
  setActiveTaskID,
  toggleReviewTab,
  toggleReportTab,
  setIsEditMode,
  setIsPreviewMode,
  setReportFileName,
  setRenderComponent,
  setReviewData,
  setReportData,
  resetState,
} = unstructuredToStructuredSlice.actions;


export default unstructuredToStructuredSlice.reducer;
